import { jsx as _jsx } from "react/jsx-runtime";
export const ModalBody = ({ children }) => {
    return _jsx("div", { className: "mb-8 mt-2 text-left", children: children });
};
export default ModalBody;
